import {useSyncExternalStore} from 'react';

// Module-scoped keyword store (§3a, global-filter-store-pattern): the search input and
// the list hook read one value, so an input in any component filters the list. Same
// useSyncExternalStore shape as the channel store, so there is no first-render race
// (FNP-593 / FNP-605).
let globalKeyword = '';
const keywordListeners: Set<() => void> = new Set();

const setKeyword = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener());
};

const subscribeKeyword = (listener: () => void) => {
    keywordListeners.add(listener);
    return () => {
        keywordListeners.delete(listener);
    };
};

const getKeywordSnapshot = (): string => globalKeyword;

// Test-only: tests share the store, so without this they leak a keyword between cases.
export const __resetReconciliationReportsKeywordForTesting = () => {
    setKeyword('');
};

export const useReconciliationReportsSearch = () => {
    const keyword = useSyncExternalStore(subscribeKeyword, getKeywordSnapshot);

    return {
        keyword,
        handleFilterByKeyword: (newKeyword: string) => setKeyword(newKeyword),
    };
};
